import '@hapana/shared/utils/type-defs.util'

import { BADGE_BACKGROUND_COLOR_MAP, BADGE_COLOR_MAP } from './assign-to-equipment-dialog.constants'

/** @type {Styles} */
export const styles = {
  dialogLoadingContainer: { padding: 3 },
  dialogContent: { padding: 0 },
  container: { paddingY: 2.5, paddingX: 4 },
  title: { mb: 2 },
  personCard: {
    border: '1px solid',
    borderColor: 'gray.12',
    borderRadius: 2,
    padding: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    mb: 3,
  },
  personInfo: { display: 'flex', flexDirection: 'column', gap: 0.5 },
  legendRow: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 3 },
  legendChip: { px: 1.5, py: 0.5, borderRadius: 1, fontWeight: 600 },
  mapWrapper: {
    display: 'grid',
    borderRadius: 6,
    alignItems: 'center',
    justifyItems: 'stretch',
    gap: 2,
  },
  mapContent: {
    gridArea: '1 / 1',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
  },
  mapGrid: { display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', rowGap: 2.5, columnGap: 0.75 },
  outerWrapper: {
    border: '1px solid',
    borderColor: 'gray.12',
    borderRadius: 4,
    padding: 3,
    backgroundColor: 'gray.0',
  },
  cardWrapper: {
    position: 'relative',
    width: 76,
    height: 55,
    cursor: 'pointer',
    border: '2px solid',
    borderRadius: 2,
  },
  imageContainer: {
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: 'transparent',
    fontSize: 0,
    lineHeight: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  equipmentImage: {
    display: 'block',
    width: '90%',
    height: '90%',
    objectFit: 'cover',
    borderRadius: 4,
  },
  medalWrapper: {
    position: 'absolute',
    bottom: -8,
    right: -8,
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'gray.0',
    boxShadow: (theme) => theme.shadows[1],
    zIndex: 1000,
  },
  queueAlert: { mt: 3, mb: 2, '.MuiTypography-root': { typography: 'medium', marginLeft: 2 } },
  footer: { display: 'flex', justifyContent: 'space-between', mt: 4 },
  selectedChip: {
    '&.MuiChip-root': {
      backgroundColor: 'secondary.lightest',
      color: 'secondary.dark',
      borderRadius: 1,
    },
    '& .MuiChip-label': { fontWeight: 600 },
  },
  availableChip: {
    '&.MuiChip-root': {
      backgroundColor: 'success.lightest',
      color: 'success.dark',
      borderRadius: 1,
    },
    '& .MuiChip-label': { fontWeight: 600 },
  },
  dirtyChip: {
    '&.MuiChip-root': {
      backgroundColor: 'warning.lightest',
      color: 'warning.dark',
      borderRadius: 1,
    },
    '& .MuiChip-label': { fontWeight: 600 },
  },
  inUseChip: {
    '&.MuiChip-root': {
      backgroundColor: 'blue.lightest',
      color: 'blue.dark',
      borderRadius: 1,
    },
    '& .MuiChip-label': { fontWeight: 600 },
  },
  medalsContainer: { display: 'flex', alignItems: 'center', gap: 1 },
  medalContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    paddingY: 0.5,
    paddingLeft: 0.5,
    paddingRight: 1,
  },
  medalIcon: {
    color: 'gray.40',
    fontSize: 16,
  },
  unavailableChip: {
    '&.MuiChip-root': {
      backgroundColor: 'error.lightest',
      color: 'error.dark',
      borderRadius: 1,
    },
    '& .MuiChip-label': { fontWeight: 600 },
  },
}

export const handleStylesWithProps = (qualityCategory) => ({
  equipmentMedalIcon: {
    color: BADGE_COLOR_MAP[qualityCategory],
    fontSize: 20,
    backgroundColor: BADGE_BACKGROUND_COLOR_MAP[qualityCategory],
  },
})
